import template from './teamRequestCard.html';
import controller from './teamRequestCard.controller';
import './teamRequestCard.scss';

let teamRequestCardComponent = {
  restrict: 'E',
  bindings: {
    modalId:'@',
    request : '<',
    onAccept : '&',
    onReject: '&',
    onDiscard: '&',
    withDelegation:'<',
    isDisabled: '<',
    isMobileApp: '<',
    cardId: '@'
  },
  template,
  controller
};

export default teamRequestCardComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestCard.component.js